/**
 * KRE-168: Android app 1.2.11+45 wraps its WebView in Flutter SafeArea.
 * Only a live message from that exact app/bridge can claim bottom-inset ownership.
 * Never infer this from user agent or persisted device information. Unknown/new
 * app versions keep CSS env() until their native layout contract is reviewed.
 */
const ATTRIBUTE = "data-native-bottom-inset";
let installed = false;
let ownerBridge = null;

function currentBridge() {
  if (typeof window === "undefined") return null;
  const bridge = window.flutter_inappwebview;
  return typeof bridge?.callHandler === "function" ? bridge : null;
}

function syncOwnership() {
  if (typeof document === "undefined") return;
  if (ownerBridge && ownerBridge !== currentBridge()) ownerBridge = null;
  if (ownerBridge) document.documentElement.setAttribute(ATTRIBUTE, "owned");
  else document.documentElement.removeAttribute(ATTRIBUTE);
}

export function initNativeBottomInsetOwnership() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  syncOwnership();
  // The attestation is document-local. BFCache can restore it only while the
  // same live bridge remains; replacement/removal requires a new native message.
  window.addEventListener("pagehide", () => document.documentElement.removeAttribute(ATTRIBUTE));
  for (const event of ["pageshow", "focus", "resize", "flutterInAppWebViewPlatformReady"]) {
    window.addEventListener(event, syncOwnership);
  }
  document.addEventListener("visibilitychange", syncOwnership);
}

export function createNativeBottomInsetReceiver() {
  initNativeBottomInsetOwnership();
  const sourceBridge = currentBridge();
  return payload => {
    if (!sourceBridge || sourceBridge !== currentBridge()) {
      syncOwnership();
      return;
    }
    const known = payload?.msgtype === "app_device_info" &&
      payload?.device?.platform === "android" &&
      payload?.app?.version === "1.2.11" && payload?.app?.buildNumber === "45";
    ownerBridge = known ? sourceBridge : null;
    syncOwnership();
  };
}
